import { FC } from 'react';
import classNames from 'classnames';

import lang from '../../lib/language';
import { isEmpty } from '../../lib/util/typeGuards';

import IconHot from '../../assets/img/hot.svg';
import Button from '../Button/Button';
import { ButtonTypesEnum } from '../Button/Button.types';
import DiscoverButton from '../DiscoverButton/DiscoverButton';
import useIsMobile from '../hooks/useIsMobile';
import NoDataAvailable from '../NoDataAvailable/NoDataAvailable';

import ContentByMarketStatus from './components/HotGappersContent/HotGappersContent';
import { HotGappersProps } from './HotGappers.types';

import styles from './HotGappers.module.scss';

const HotGappers: FC<HotGappersProps> = ({
  isError,
  isGapUpSelected,
  isGapDownSelected,
  isMarketHours,
  isReady,
  onTabChange,
  onViewAllClick,
  ...contentProps
}: HotGappersProps): JSX.Element => {
  const { isMobile } = useIsMobile();
  const { rows } = contentProps;
  const hasData = isMarketHours && !isEmpty(rows);

  const getContent = (): JSX.Element => {
    if (isMarketHours && !hasData && (isReady || isError)) {
      return (
        <NoDataAvailable
          className={styles.noDataToDisplay}
          isNoDataIcon
          title={lang.commonDiscover52WeekNoDataAll()}
        />
      );
    }

    return (
      <ContentByMarketStatus
        {...contentProps}
        isGapUpSelected={isGapUpSelected}
        isMarketHours={isMarketHours}
        isReady={isReady}
        onViewAllClick={onViewAllClick}
      />
    );
  };

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.wrapperMob]: isMobile,
        [styles.wrapperPosition]: !isMobile,
      })}
    >
      <div className={styles.titleWrapper}>
        <div className={styles.titleRow}>
          <div>
            <span className={classNames(styles.title, GlobalClassesEnum.CommonDiscoverTitle)}>
              {lang.gappersTitle()}
              <img className={styles.icon} src={IconHot} alt="icon bank" />
            </span>
            <span className={styles.subtitle}>
              {lang.gappersTrackEveryStock()}
            </span>
          </div>
          {hasData && onViewAllClick && (
            isMobile ? (
              <Button
                variant={ButtonTypesEnum.Link}
                onClick={onViewAllClick}
                className={styles.viewAll}
              >
                {lang.commonViewAll()}
              </Button>
            ) : (
              <DiscoverButton
                onClick={onViewAllClick}
                text={lang.commonViewAll()}
              />
            )
          )}
        </div>
        {isMarketHours && (
          <div className={styles.tabsWrapper}>
            <div
              className={classNames(styles.tabs, {
                [styles.tabMobWidth]: isMobile,
              })}
            >
              <Button
                className={classNames(styles.tab, {
                  [styles.tabActive]: isGapUpSelected,
                  [styles.tabInactive]: !isGapUpSelected,
                  [styles.tabMob]: isMobile,
                  [styles.tabWebWidth]: !isMobile,
                  [styles.tabMobWidth]: isMobile,
                })}
                disabled={!isReady}
                onClick={() => onTabChange(true)}
              >
                {lang.gappersTitleGapUp()}
              </Button>

              <Button
                className={classNames(styles.tab, {
                  [styles.tabActive]: isGapDownSelected,
                  [styles.tabInactive]: !isGapDownSelected,
                  [styles.tabMob]: isMobile,
                  [styles.tabWebWidth]: !isMobile,
                  [styles.tabMobWidth]: isMobile,
                })}
                disabled={!isReady}
                onClick={() => onTabChange(false)}
              >
                {lang.gappersTitleGapDown()}
              </Button>

            </div>
          </div>
        )}
      </div>
      {getContent()}
    </div>
  );
};

export default HotGappers;
